import './index.scss';
import { Button } from 'primereact/button';
import { ProgressSpinner } from 'primereact/progressspinner';
import BlogTemplate from 'components/blog-template';
import { useNavigate } from 'react-router-dom';
import { getMarketContent } from 'utils/marketContent';
import { useHubspotBlog } from '../../../hooks/userHooks';

export default function ShopBlogs() {
  const navigate = useNavigate();

  const market = getMarketContent();

  const dataBlogID = market.blogID;
  const { blogPosts, fetching } = useHubspotBlog(dataBlogID);

  return (
    <section className="ShopBlogs">
      <h2 className="section_header">MEET OUR MICROPRENEURS</h2>

      <div className="grid">
        {fetching ? (
          <ProgressSpinner />
        ) : (
          <>
            {blogPosts?.slice(0, 3).map(blog => (
              <div key={blog.id} className="col-12 md:col-4">
                <BlogTemplate {...blog} />
              </div>
            ))}
            <div className="col-12 text-center ShopBlogs__view-more-btn">
              <Button
                label="View More"
                className="c-button-black mt-3 mb-3 "
                onClick={() => navigate('/blog-explorer')}
              />
            </div>
          </>
        )}
      </div>
    </section>
  );
}
